import { render, staticRenderFns } from "./detailApproval.vue?vue&type=template&id=8ab0b63e"
import script from "./detailApproval.vue?vue&type=script&lang=js"
export * from "./detailApproval.vue?vue&type=script&lang=js"
import style0 from "./detailApproval.vue?vue&type=style&index=0&id=8ab0b63e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports